// Services
import "DS/font-service";
// Boilerplates
import { NavTeslaFullScreen } from "CompLibTheme/boilerplates/nav-tesla-full-screen";
import "CompLibTheme/boilerplates/footer-4col";
import "CompLib/basics/image-resp";
import { ExoviaSmoothScrolling } from "CompLib/services/gsap-smooth-scrolling-page";
import { ToggleFixedNavbarStyles } from "CompLib/services/toggle-fixed-navbar-styles";
import { BeforeAfterImageScrollSlide } from "CompLibTheme/before-after-image-scroll-slide";
import "CompLibTheme/links/exovia-ripple";

import { SmoothInternalLinks } from "CompLibTheme/smooth-internal-links";

import { IwaraImageFancyRawImgSize } from "CompLib/galleries/iwara-image-fancy-raw-img-size";
import "CompLib/galleries/iwara-image-fancy-raw-img-size/effects/kb_on_hover";

// Instatiations BP
new ToggleFixedNavbarStyles();
const smoothScroll = new ExoviaSmoothScrolling();
new NavTeslaFullScreen({ smoothScroll });
new SmoothInternalLinks(smoothScroll);
new BeforeAfterImageScrollSlide();
const myIwara = new IwaraImageFancyRawImgSize();

// import 'page styles last';
import "./scss/styles.scss";
